/**
 * Adzuki.Navigation
 */

(function Navigation($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		var navbar   = $(".navbar-fixed-top");

		navbar.on('click', '.navbar-more-btn', function showMore(e)
		{
			e.preventDefault();
			// toggle more links
			navbar.find(".more-menu").toggle('show');
		});
	});

}(jQuery, window.Adzuki || {}));
